export default "__VITE_ASSET__ed0cc2ca__"